
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { list_type, record_type, class_type, int32_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { StocktakingId_$reflection } from "./Shared.js";
import { StocktakingState_$reflection } from "./Stocktaking.js";
import { DashboardData_$reflection } from "./Dashboard.js";
import { DashboardConfigurationDto_$reflection } from "./DashboardConfiguration.js";

export class DashboardAvailabilityView extends Record {
    constructor(Name, PeriodDays, StartDate, EndDate, AvailableCount, PartiallyAvailableCount, UnavailableCount) {
        super();
        this.Name = Name;
        this.PeriodDays = (PeriodDays | 0);
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.AvailableCount = (AvailableCount | 0);
        this.PartiallyAvailableCount = (PartiallyAvailableCount | 0);
        this.UnavailableCount = (UnavailableCount | 0);
    }
}

export function DashboardAvailabilityView_$reflection() {
    return record_type("Shared.DashboardOverview.DashboardAvailabilityView", [], DashboardAvailabilityView, () => [["Name", string_type], ["PeriodDays", int32_type], ["StartDate", class_type("System.DateTime")], ["EndDate", class_type("System.DateTime")], ["AvailableCount", int32_type], ["PartiallyAvailableCount", int32_type], ["UnavailableCount", int32_type]]);
}

export class DashboardStocktakingInfo extends Record {
    constructor(Id, Name, State, StartDate, EndDate, ResponsiblePersons, CountedPositions, TotalPositions) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.State = State;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.ResponsiblePersons = ResponsiblePersons;
        this.CountedPositions = (CountedPositions | 0);
        this.TotalPositions = (TotalPositions | 0);
    }
}

export function DashboardStocktakingInfo_$reflection() {
    return record_type("Shared.DashboardOverview.DashboardStocktakingInfo", [], DashboardStocktakingInfo, () => [["Id", StocktakingId_$reflection()], ["Name", string_type], ["State", StocktakingState_$reflection()], ["StartDate", class_type("System.DateTime")], ["EndDate", class_type("System.DateTime")], ["ResponsiblePersons", list_type(string_type)], ["CountedPositions", int32_type], ["TotalPositions", int32_type]]);
}

export class DashboardDto extends Record {
    constructor(Data, Configuration, AvailabilityViews, RunningStocktakings) {
        super();
        this.Data = Data;
        this.Configuration = Configuration;
        this.AvailabilityViews = AvailabilityViews;
        this.RunningStocktakings = RunningStocktakings;
    }
}

export function DashboardDto_$reflection() {
    return record_type("Shared.DashboardOverview.DashboardDto", [], DashboardDto, () => [["Data", DashboardData_$reflection()], ["Configuration", DashboardConfigurationDto_$reflection()], ["AvailabilityViews", list_type(DashboardAvailabilityView_$reflection())], ["RunningStocktakings", list_type(DashboardStocktakingInfo_$reflection())]]);
}

